import styled from 'styled-components'

export const DemandStyle = styled.div`
  margin: 55px 0 55px 0;
  display: flex;
  padding: 20px 0;
  position: relative;
  > img {
    position: absolute;
    z-index: -1;
    width: 100%;
    display: block;
    left: 0;
    right: 0;
    bottom: -30px;
  }

  .scroll {
    .scroll-col {
      margin-bottom: 20px;
    }
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    background: linear-gradient(to top, #e8dce1, rgba(227, 239, 249, 0));
    .scroll {
      overflow-x: scroll;
      overflow-y: hidden;
      white-space: nowrap;
      display: block;
      -webkit-overflow-scrolling: touch;
      .scroll-col {
        box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
        background: #fff;
        height: 100%;
        flex-basis: 70%;
        max-width: 70%;
        margin-right: 15px;
        display: inline-flex;
        vertical-align: top;
        border-radius: 20px;
        margin-bottom: 0;
      }
    }
    .title.top {
      display: none;
    }
    .card-image-box {
      box-shadow: unset !important;
      padding: 15px;
      height: 100%;
      padding: 0 !important;
    }
    .card-image-box .text .desc {
      display: block;
      white-space: normal;
    }
    .card-image-box .text {
      min-height: 208px;
    }
    > img {
      display: none;
    }
  }
  .column-bottom {
    margin-bottom: 60px;
  }
  .top-margin {
    margin-top: 20px;
  }
`
